module.exports = "<a class=\"crumb\"\r\n    ng-repeat-start=\"crumb in $ctrl.breadcrumbs track by crumb.route\"\r\n    ui-sref=\"{{crumb.route}}\"\r\n    ng-if=\"!$last\">\r\n  {{crumb.displayName}}\r\n</a>\r\n<a class=\"crumb current\"\r\n    ng-repeat-end\r\n    ng-click=\"$ctrl.clearCache()\"\r\n    ui-sref=\"{{crumb.route}}\"\r\n    ui-sref-opts=\"{reload: true}\"\r\n    ng-if=\"$last\">\r\n  {{crumb.displayName}}\r\n</a>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/components/breadcrumbs/template.html
// module id = 167
// module chunks = 0